<template>
  <div class="searchPage"
    :class="{'searchPage-loaded': algoliaFinish}">
    <div v-if="algoliaFinish">
      <breadcrumbs
      v-if="searchPage"
      :categoryCurrent="currentCategory"
      ></breadcrumbs>
      <search-header
        :notFound="notFound"
        :querySearch="querySearch"
        v-if="searchFinish && productCount >= 0 && !postPage"
        headerType="products"
        :pageNotPrest="notPagePresta"
        @backHome="backHome"
        @resetSearch="resetSearch"
        :categorySelect="currentCategory"
      ></search-header>
      <div class="loader" v-if="!searchFinish || filterLoad">
        <span class="spinner">Loading</span>
      </div>
      <search-product
        :items="queryResultsProducts"
        :multipleList="multipleList"
        :querySearch="querySearch"
        :isOnly="productPage"
        :filterVisible="filterVisible"
        :visibleMobileProp="filterVisible > 3"
        @changedFilter="onchangedFilter"
        @currentPageGo="currentPageGo($event)"
        @changeSort="changeSort($event)"
        v-if="!notFound && searchFinish && !filterLoad"
        :key="searchProductKey"
        :pageNotPrest="notPagePresta"
      ></search-product>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line camelcase
import { product_name, index } from '@/api/algolia/api'
import SearchHeader from '@/components/Algolia/components/search-header'
import SearchProduct from '@/components/Algolia/components/search-products'
import Breadcrumbs from '@/components/Algolia/components/breadcrumbs'
import getUrlParameter from '@/shared/geturlparamter'
import updateUrlParametr from '@/shared/updateurlparametr'
import removeUrlParametr from '@/shared/removeurlparametr'
import {renderProductsListRatings} from '@/modules'

export default {
  name: 'app',
  data: function () {
    return {
      querySearch: '',
      queryResultsProducts: [],
      multipleList: [],
      notFound: false,
      productCount: 0,
      postperpage: 10,
      productperpage: 48,
      filterVisible: 3,
      pageCurrent: 0,
      productPage: true,
      postPage: false,
      searchFinish: false,
      algoliaFinish: false,
      firstPage: true,
      filtersItem: undefined,
      filtersArrayFromURL: undefined,
      filterLoad: false,
      searchProductKey: 0,
      notPagePresta: false,
      sortWay: '',
      sortBy: '',
      currentCategory: undefined,
      // eslint-disable-next-line no-undef
      prestaUrl: baseUri,
      // eslint-disable-next-line no-undef
      searchPage: isSearch || undefined,
      // eslint-disable-next-line no-undef
      brandName: brandName || undefined,
      // eslint-disable-next-line no-undef
      categoryId: idCategory || undefined,
      // eslint-disable-next-line no-undef
      labels: labels || undefined
    }
  },
  components: {
    SearchHeader,
    SearchProduct,
    Breadcrumbs
  },
  created: function () {
    let pagePrestaCategory = document.querySelectorAll('.show_if_vue')
    let pageNotPresta = document.querySelectorAll('.hide_if_vue')
    let orderInit = getUrlParameter('orderby')
    this.querySearch = getUrlParameter('search_query')
    let searchInput = document.querySelectorAll('.search_query')
    searchInput.forEach(item => {
      item.value = this.querySearch
    })
    this.onClickCategory()
    // document.getElementById('search_query_top').value = this.querySearch
    this.pageCurrent = getUrlParameter('p') || 0
    let pageUrl = Number(getUrlParameter('p'))
    if (getUrlParameter('p') !== '' && pageUrl !== 1 && pageUrl !== 0) {
      this.pageCurrent = pageUrl - 1
    }
    if (pageUrl === 1 || pageUrl === 0 || pageUrl === '') {
      this.pageCurrent = 0
    } else {
      this.pageCurrent = pageUrl - 1
    }
    this.productPage = true
    this.firstPage = false
    this.productperpage = 48
    this.searchFinish = true
    // eslint-disable-next-line no-undef

    let filtersArray = []
    let filtersString = getUrlParameter('filters')
    let filtersStringItem = filtersString.split('|')
    filtersStringItem.forEach(item => {
      let itemsplit = item.split(':')
      let itemArray = []
      for (let i = 0; i < itemsplit.length; i++) {
        if (i === 0) {
          itemArray['name'] = itemsplit[i]
        } else {
          itemArray['value'] = []
          itemsplit[i].split(',').forEach(value => {
            itemArray['value'].push(value)
          })
        }
      }
      filtersArray.push(itemArray)
    })
    this.filtersArrayFromURL = filtersArray
    // eslint-disable-next-line no-undef
    if (filtersString.length > 0 || isSearch || orderInit.length > 0) {
      this.notPagePresta = true
      pageNotPresta.forEach(function (item) {
        item.style.display = 'none'
      })
      pagePrestaCategory.forEach(function (item) {
        item.style.display = 'block'
      })
      this.searchProductKey++
    }
    let searchMobile = document.getElementById('resetsearch')
    searchMobile.addEventListener('click', () => {
      this.resetSearchMobile()
    })
    if (this.querySearch) {
      searchMobile.style.display = 'block'
    } else {
      searchMobile.style.display = 'none'
    }
  },
  mounted: function () {
    let filterStringAlgolia = ''
    let selectedParent = []
    let filterArray = []
    if (this.filtersArrayFromURL) {
      this.filtersArrayFromURL.forEach(item => {
        let filterGroup = []
        if (item.value !== undefined) {
          item.value.forEach(item2 => {
            if (filterStringAlgolia.length === 0) {
              if (item.name === 'brand') {
                selectedParent.push(item.name)
                filterGroup.push(item.name + ':' + item2)
              } else if (item.name === 'labels') {
                selectedParent.push(item.name)
                filterGroup.push(item.name + ':' + item2)
              } else {
                selectedParent.push('features.' + item.name)
                filterGroup.push('features.' + item.name + ':' + item2)
              }
            }
          })
        }
        if (filterGroup.length > 0) {
          filterArray.push(filterGroup)
        }
      })
    }
    if (getUrlParameter('category')) {
      this.categoryId = getUrlParameter('category')
      var categoryDom = document.querySelectorAll('body:not(.category) .category-item-vue')
      categoryDom.forEach(item => {
        if (item.getAttribute('data-id') === this.categoryId) {
          item.classList.add('selected')
        }
      })
    }
    var categoryDomClick = document.querySelectorAll('body:not(.category) .category-item-vue')
    categoryDomClick.forEach(item => {
      item.addEventListener('click', () => {
        if (item.previousElementSibling !== null) {
          // eslint-disable-next-line no-undef
          if (jQuery(item.previousElementSibling).hasClass('CLOSE')) {
            // eslint-disable-next-line no-undef
            jQuery(item.previousElementSibling).click()
          }
        }
      })
    })
    // eslint-disable-next-line no-undef
    if (this.categoryId) {
      if (filterStringAlgolia.length > 0) {
        // eslint-disable-next-line no-undef
        filterStringAlgolia += ' AND categories.id_category:' + this.categoryId
      } else {
        // eslint-disable-next-line no-undef
        filterStringAlgolia += 'categories.id_category:' + this.categoryId
      }
    }
    if (this.brandName) {
      if (filterStringAlgolia.length > 0) {
        // eslint-disable-next-line no-undef
        filterStringAlgolia += ' AND brand:' + this.brandName
      } else {
        // eslint-disable-next-line no-undef
        filterStringAlgolia += 'brand:' + this.brandName
      }
    }
    if (this.labels) {
      if (filterStringAlgolia.length > 0) {
        // eslint-disable-next-line no-undef
        filterStringAlgolia += ' AND labels:' + this.labels
      } else {
        // eslint-disable-next-line no-undef
        filterStringAlgolia += 'labels:' + this.labels
      }
    }
    let sortType = ''
    if ((getUrlParameter('orderway') === 'desc') && (getUrlParameter('orderby') === 'price')) {
      sortType = '_price_desc'
    } else if ((getUrlParameter('orderway') === 'asc') && (getUrlParameter('orderby') === 'price')) {
      sortType = '_price_asc'
    } else if ((getUrlParameter('orderby') === 'promo')) {
      sortType = '_promo'
    } else if ((getUrlParameter('orderby') === 'new')) {
      sortType = '_new'
    } else if ((getUrlParameter('orderby') === 'rate')) {
      sortType = '_rate'
    }
    let algoliaQuery = [{
      // eslint-disable-next-line camelcase
      indexName: product_name + sortType,
      query: this.querySearch,
      params: {
        hitsPerPage: this.productperpage,
        filters: filterStringAlgolia,
        facetFilters: filterArray,
        page: this.pageCurrent,
        facets: ['*']
      }
    }]

    selectedParent = selectedParent.filter(function (item, pos) {
      return selectedParent.indexOf(item) === pos
    })
    selectedParent.forEach(item => {
      let filterArraySlice = filterArray.map(item2 => {
        if (!item2.toString().includes(item)) {
          return item2
        } else {
          return ''
        }
      })
      let query = {
        // eslint-disable-next-line camelcase
        indexName: product_name + sortType,
        query: this.querySearch,
        filters: filterStringAlgolia,
        params: {
          facets: item,
          facetFilters: filterArraySlice
        }
      }
      algoliaQuery.push(query)
    })

    index
      .search(algoliaQuery)
      .then(response => {
        this.algoliaFinish = true
        this.queryResultsProducts = []
        this.searchProductKey++
        this.queryResultsProducts = response.results[0]
        this.productCount = response.results[0].nbHits
        this.multipleList = response
        this.searchFinish = true
        if (
          this.productCount === 0 ||
          this.queryResultsProducts.hits.length === 0
        ) {
          this.notFound = true
        }
        setTimeout(() => {
          renderProductsListRatings()
        }, 1)
        this.filterCategory(response.results[0])
        // eslint-disable-next-line no-undef
        if (jQuery(jQuery('.tree')[0]).children('.li-has-id').length === 1) {
          if (this.categoryId === undefined) {
            // eslint-disable-next-line no-undef
            jQuery(jQuery(jQuery('.tree')[0]).children('.li-has-id')[0]).children('.category-item-vue')[0].classList.add('noupdateurl')
            // eslint-disable-next-line no-undef
            jQuery(jQuery(jQuery('.tree')[0]).children('.li-has-id')[0]).children('.category-item-vue')[0].click()
            // eslint-disable-next-line no-undef
            jQuery(jQuery(jQuery('.tree')[0]).children('.li-has-id')[0]).children('.category-item-vue')[0].classList.remove('noupdateurl')
          }
        }
        this.categoryList()
      })
    let clearFilters = document.querySelector('body:not(.category) .clear-categories')
    if (clearFilters) {
      clearFilters.addEventListener('click', link => {
        this.clearCategory()
      })
    }
  },
  methods: {
    resetSearch () {
      const deleteRegex = new RegExp(['search_query', 'controller', 'category'].join('=|') + '=')
      const params = location.search.slice(1).split('&')
      let search = []
      for (let i = 0; i < params.length; i++) if (deleteRegex.test(params[i]) === false) search.push(params[i])
      let url = this.currentCategory[this.currentCategory.length - 1]['1'] + '?' + search.join('&')
      window.location.assign(url)
    },
    backHome () {
      window.location.assign(this.prestaUrl)
    },
    resetSearchMobile () {
      window.location.assign(this.prestaUrl + 'szukaj')
    },
    categoryList () {
      this.currentCategory = []
      // eslint-disable-next-line no-undef
      this.currentCategory.push([jQuery('.selected').closest('ul').closest('li').closest('ul').closest('li').closest('ul').prev().html(), jQuery('.selected').closest('ul').closest('li').closest('ul').closest('li').closest('ul').prev().attr('href')])
      // eslint-disable-next-line no-undef
      this.currentCategory.push([jQuery('.selected').closest('ul').closest('li').closest('ul').prev().html(), jQuery('.selected').closest('ul').closest('li').closest('ul').prev().attr('href')])
      // eslint-disable-next-line no-undef
      this.currentCategory.push([jQuery('.selected').closest('ul').prev().html(), jQuery('.selected').closest('ul').prev().attr('href')])
      // eslint-disable-next-line no-undef
      this.currentCategory.push([jQuery('.selected').html(), jQuery('.selected').attr('href')])
    },
    clearCategory () {
      let clearFilters = document.querySelector('body:not(.category) .clear-categories')
      let categoryLink = document.querySelectorAll('body:not(.category) .category-item-vue')
      let filterStringAlgolia = ''
      let filterArray = []
      let selectedParent = []
      clearFilters.classList.remove('show-clear-categories')
      this.categoryId = undefined
      let sortType = ''
      if ((getUrlParameter('orderway') === 'desc') && (getUrlParameter('orderby') === 'price')) {
        sortType = '_price_desc'
      } else if ((getUrlParameter('orderway') === 'asc') && (getUrlParameter('orderby') === 'price')) {
        sortType = '_price_asc'
      } else if ((getUrlParameter('orderby') === 'promo')) {
        sortType = '_promo'
      } else if ((getUrlParameter('orderby') === 'new')) {
        sortType = '_new'
      } else if ((getUrlParameter('orderby') === 'rate')) {
        sortType = '_rate'
      }
      // eslint-disable-next-line no-undef
      jQuery('.li-has-id ul').hide()
      // eslint-disable-next-line no-undef
      jQuery('.grower').removeClass('OPEN')
      // eslint-disable-next-line no-undef
      jQuery('.grower').addClass('CLOSE')
      if (this.labels) {
        filterStringAlgolia += 'labels:' + this.labels
      }
      if (this.brandName) {
        filterStringAlgolia += 'brand:' + this.brandName
      }
      let algoliaQuery = [
        {
          // eslint-disable-next-line camelcase
          indexName: product_name + sortType,
          query: this.querySearch,
          params: {
            hitsPerPage: this.productperpage,
            filters: filterStringAlgolia,
            facetFilters: filterArray,
            page: 0,
            facets: ['*']
          }
        }
      ]
      selectedParent = selectedParent.filter(function (item, pos) {
        return selectedParent.indexOf(item) === pos
      })

      selectedParent.forEach(item => {
        let filterArraySlice = filterArray.map(item2 => {
          if (!item2.toString().includes(item)) {
            return item2
          } else {
            return ''
          }
        })
        let query = {
          // eslint-disable-next-line camelcase
          indexName: product_name + sortType,
          query: this.querySearch,
          filters: filterStringAlgolia,
          params: {
            facets: item,
            facetFilters: filterArraySlice
          }
        }
        algoliaQuery.push(query)
      })
      index
        .search(algoliaQuery)
        .then(response => {
          this.filterCategory(response.results[0])
          this.algoliaFinish = true
          this.queryResultsProducts = []
          this.searchProductKey++
          this.queryResultsProducts = response.results[0]
          this.productCount = response.results[0].nbHits
          this.searchFinish = true
          if (
            this.productCount === 0 ||
            this.queryResultsProducts.hits.length === 0
          ) {
            this.notFound = true
          } else {
            this.notFound = false
          }
          setTimeout(() => {
            renderProductsListRatings()
          }, 1)
          this.searchProductKey++
          removeUrlParametr(['filters', 'p', 'category'])
          this.notPagePresta = true
          categoryLink.forEach(link2 => {
            link2.classList.remove('selected')
          })
          this.categoryList()
        })
    },
    onClickCategory (clear) {
      let categoryLink = document.querySelectorAll('body:not(.category) .category-item-vue')
      let menu = document.querySelectorAll('body:not(.category) .categories_tree_block > ul ul')
      let pagePresta = document.querySelectorAll('.hide_if_vue')
      categoryLink.forEach(item => {
        item.addEventListener('click', link => {
          link.preventDefault()
          let clearFilters = document.querySelector('body:not(.category) .clear-categories')
          clearFilters.classList.add('show-clear-categories')
          this.categoryId = Number(item.getAttribute('data-id'))
          let sortType = ''
          if ((getUrlParameter('orderway') === 'desc') && (getUrlParameter('orderby') === 'price')) {
            sortType = '_price_desc'
          } else if ((getUrlParameter('orderway') === 'asc') && (getUrlParameter('orderby') === 'price')) {
            sortType = '_price_asc'
          } else if ((getUrlParameter('orderby') === 'promo')) {
            sortType = '_promo'
          } else if ((getUrlParameter('orderby') === 'new')) {
            sortType = '_new'
          } else if ((getUrlParameter('orderby') === 'rate')) {
            sortType = '_rate'
          }
          let filterStringAlgolia = ''
          let filterArray = []
          let selectedParent = []
          if (this.categoryId) {
            filterStringAlgolia += 'categories.id_category:' + this.categoryId
          }
          if (this.brandName) {
            filterStringAlgolia += ' AND brand:' + this.brandName
          }
          if (this.labels) {
            filterStringAlgolia += ' AND labels:' + this.labels
          }
          let url = window.location.search
          if (item.classList.contains('noupdateurl') !== true) {
            window.history.replaceState(
              null,
              '',
              updateUrlParametr(url, 'category', this.categoryId)
            )
          } else {
            // document.location.href = String(url).replace('?', '')
          }
          if (!item.classList.contains('selected')) {
            let algoliaQuery = [
              {
                // eslint-disable-next-line camelcase
                indexName: product_name + sortType,
                query: this.querySearch,
                params: {
                  hitsPerPage: this.productperpage,
                  filters: filterStringAlgolia,
                  facetFilters: filterArray,
                  page: 0,
                  facets: ['*']
                }
              }
            ]

            selectedParent = selectedParent.filter(function (item, pos) {
              return selectedParent.indexOf(item) === pos
            })

            selectedParent.forEach(item => {
              let filterArraySlice = filterArray.map(item2 => {
                if (!item2.toString().includes(item)) {
                  return item2
                } else {
                  return ''
                }
              })
              let query = {
                // eslint-disable-next-line camelcase
                indexName: product_name + sortType,
                query: this.querySearch,
                filters: filterStringAlgolia,
                params: {
                  facets: item,
                  facetFilters: filterArraySlice
                }
              }
              algoliaQuery.push(query)
            })
            index
              .search(algoliaQuery)
              .then(response => {
                this.algoliaFinish = true
                this.queryResultsProducts = []
                this.searchProductKey++
                this.queryResultsProducts = response.results[0]
                this.productCount = response.results[0].nbHits
                this.multipleList = response
                this.searchFinish = true
                if (
                  this.productCount === 0 ||
                  this.queryResultsProducts.hits.length === 0
                ) {
                  this.notFound = true
                } else {
                  this.notFound = false
                }
                setTimeout(() => {
                  renderProductsListRatings()
                }, 1)
                this.searchProductKey++
                if (getUrlParameter('filters').length > 0) {
                  removeUrlParametr(['filters'])
                }
                if (getUrlParameter('p').length > 0) {
                  removeUrlParametr(['p'])
                }
                this.notPagePresta = true
                pagePresta.forEach(function (item) {
                  item.style.display = 'none'
                })
                categoryLink.forEach(link2 => {
                  link2.classList.remove('selected')
                })
                item.classList.add('selected')
                this.filterCategory(response.results[0])
                this.categoryList()
              })

            let grower = document.querySelectorAll('body:not(.category) .categories_tree_block > ul .grower')
            // eslint-disable-next-line no-undef
            if (!jQuery(item).closest('ul').hasClass('tree')) {
              // eslint-disable-next-line no-undef
              menu.forEach(menuList => {
                menuList.style.display = 'none'
              })
              grower.forEach(growerItem => {
                growerItem.classList.remove('OPEN')
                growerItem.classList.add('CLOSE')
              })
              // eslint-disable-next-line no-undef
              jQuery(item).closest('ul').closest('li').closest('ul').closest('li').closest('ul').closest('li').closest('ul').show()
              // eslint-disable-next-line no-undef
              jQuery(item).closest('ul').closest('li').closest('ul').closest('li').closest('ul').show()
              // eslint-disable-next-line no-undef
              jQuery(item).closest('ul').show()
              // eslint-disable-next-line no-undef
              jQuery(item).closest('ul').closest('li').closest('ul').show()
            } else {
              // eslint-disable-next-line no-undef
              menu.forEach(menuList => {
                menuList.style.display = 'none'
              })
              grower.forEach(growerItem => {
                growerItem.classList.remove('OPEN')
                growerItem.classList.add('CLOSE')
              })
              // eslint-disable-next-line no-undef
              jQuery(item).next('ul').show()
              // eslint-disable-next-line no-undef
              jQuery(item).prev('.grower').removeClass('CLOSE OPEN').addClass('OPEN')
            }

            // eslint-disable-next-line no-undef
            jQuery(item).closest('ul').closest('li').find('> .grower').removeClass('CLOSE OPEN').addClass('OPEN')
            // eslint-disable-next-line no-undef
            jQuery(item).closest('ul').closest('li').closest('ul').closest('li').find('> .grower').removeClass('CLOSE OPEN').addClass('OPEN')
            // eslint-disable-next-line no-undef
            jQuery(item).closest('ul').closest('li').closest('ul').closest('li').closest('ul').closest('li').find('> .grower').removeClass('CLOSE OPEN').addClass('OPEN')
          }
        })
      })
    },
    currentPageGo (number) {
      this.pageCurrent = number
      let filterStringAlgolia = ''
      let filtersArray = []
      let selectedParent = []
      let filterArray = []
      let filtersString = getUrlParameter('filters')
      let filtersStringItem = filtersString.split('|')
      filtersStringItem.forEach(item => {
        let itemsplit = item.split(':')
        let itemArray = []
        for (let i = 0; i < itemsplit.length; i++) {
          if (i === 0) {
            itemArray['name'] = itemsplit[i]
          } else {
            itemArray['value'] = []
            itemsplit[i].split(',').forEach(value => {
              itemArray['value'].push(value)
            })
          }
        }
        filtersArray.push(itemArray)
      })
      this.filtersArrayFromURL = filtersArray
      if (this.filtersArrayFromURL) {
        this.filtersArrayFromURL.forEach(item => {
          let filterGroup = []
          if (item.value !== undefined) {
            item.value.forEach(item2 => {
              if (filterStringAlgolia.length === 0) {
                if (item.name === 'brand') {
                  selectedParent.push(item.name)
                  filterGroup.push(item.name + ':' + item2)
                } else if (item.name === 'labels') {
                  selectedParent.push(item.name)
                  filterGroup.push(item.name + ':' + item2)
                } else {
                  selectedParent.push('features.' + item.name)
                  filterGroup.push('features.' + item.name + ':' + item2)
                }
              }
            })
          }
          if (filterGroup.length > 0) {
            filterArray.push(filterGroup)
          }
        })
      }
      // eslint-disable-next-line no-undef
      if (this.categoryId) {
        if (filterStringAlgolia.length > 0) {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += ' AND categories.id_category:' + this.categoryId
        } else {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += 'categories.id_category:' + this.categoryId
        }
      }
      if (this.brandName) {
        if (filterStringAlgolia.length > 0) {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += ' AND brand:' + this.brandName
        } else {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += 'brand:' + this.brandName
        }
      }
      if (this.labels) {
        if (filterStringAlgolia.length > 0) {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += ' AND labels:' + this.labels
        } else {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += 'labels:' + this.labels
        }
      }
      let sortType = ''
      if ((getUrlParameter('orderway') === 'desc') && (getUrlParameter('orderby') === 'price')) {
        sortType = '_price_desc'
      } else if ((getUrlParameter('orderway') === 'asc') && (getUrlParameter('orderby') === 'price')) {
        sortType = '_price_asc'
      } else if ((getUrlParameter('orderby') === 'promo')) {
        sortType = '_promo'
      } else if ((getUrlParameter('orderby') === 'new')) {
        sortType = '_new'
      } else if ((getUrlParameter('orderby') === 'rate')) {
        sortType = '_rate'
      }
      let algoliaQuery = [
        {
          // eslint-disable-next-line camelcase
          indexName: product_name + sortType,
          query: this.querySearch,
          params: {
            hitsPerPage: this.productperpage,
            filters: filterStringAlgolia,
            facetFilters: filterArray,
            page: this.pageCurrent - 1,
            facets: ['*']
          }
        }
      ]

      selectedParent = selectedParent.filter(function (item, pos) {
        return selectedParent.indexOf(item) === pos
      })

      selectedParent.forEach(item => {
        let filterArraySlice = filterArray.map(item2 => {
          if (!item2.toString().includes(item)) {
            return item2
          } else {
            return ''
          }
        })
        let query = {
          // eslint-disable-next-line camelcase
          indexName: product_name + sortType,
          query: this.querySearch,
          filters: filterStringAlgolia,
          params: {
            facets: item,
            facetFilters: filterArraySlice
          }
        }
        algoliaQuery.push(query)
      })
      index
        .search(algoliaQuery)
        .then(response => {
          this.algoliaFinish = true
          this.queryResultsProducts = []
          this.searchProductKey++
          this.queryResultsProducts = response.results[0]
          this.productCount = response.results[0].nbHits
          this.searchFinish = true
          if (
            this.productCount === 0 ||
            this.queryResultsProducts.hits.length === 0
          ) {
            this.notFound = true
          }
          setTimeout(() => {
            renderProductsListRatings()
          }, 1)
          this.filterCategory(response.results[0])
          this.searchProductKey++
        })
      this.searchProductKey++
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }, 200)
      let url = window.location.search
      if (this.pageCurrent === 1) {
        window.history.replaceState(
          null,
          '',
          updateUrlParametr(url, 'p', this.pageCurrent)
        )
      } else {
        window.history.replaceState(
          null,
          '',
          updateUrlParametr(url, 'p', this.pageCurrent)
        )
      }
    },
    onchangedFilter (filters) {
      let pagePresta = document.querySelectorAll('.hide_if_vue')
      let pagePrestaCategory = document.querySelectorAll('.show_if_vue')
      if (filters !== undefined) {
        this.filtersItem = filters
      }
      if (this.filtersItem) {
        this.filterVisible = 10000
        let selectedStringURL = ''
        let filterStringAlgolia = ''
        let filterArray = []
        let selectedParent = []
        this.filtersItem.forEach(item => {
          let setName = true
          let filterGroup = []
          item.value.forEach(item2 => {
            if (item2.selected) {
              if (item.name === 'brand') {
                selectedParent.push(item.name)
                filterGroup.push(item.name + ':' + item2.name)
              } else if (item.name === 'labels') {
                selectedParent.push(item.name)
                filterGroup.push(item.name + ':' + item2.name)
              } else {
                selectedParent.push('features.' + item.name)
                filterGroup.push('features.' + item.name + ':' + item2.name)
              }
              if (setName) {
                selectedStringURL += '|' + item.name + ':'
                selectedStringURL += item2.name
                setName = false
              } else {
                selectedStringURL += ',' + item2.name
              }
            }
          })
          if (filterGroup.length > 0) {
            filterArray.push(filterGroup)
          }
        })
        let sortType = ''
        let sortUrl = ''
        if ((getUrlParameter('orderway') === 'desc') && (getUrlParameter('orderby') === 'price')) {
          sortType = '_price_desc'
          sortUrl = 'orderby=price&orderway=desc'
        } else if ((getUrlParameter('orderway') === 'asc') && (getUrlParameter('orderby') === 'price')) {
          sortType = '_price_asc'
          sortUrl = 'orderby=price&orderway=asc'
        } else if ((getUrlParameter('orderby') === 'promo')) {
          sortType = '_promo'
          sortUrl = 'orderby=promo'
        } else if ((getUrlParameter('orderby') === 'new')) {
          sortType = '_new'
          sortUrl = 'orderby=new'
        } else if ((getUrlParameter('orderby') === 'rate')) {
          sortType = '_rate'
          sortUrl = 'orderby=rate'
        }
        if (this.categoryId) {
          if (filterStringAlgolia.length > 0) {
            // eslint-disable-next-line no-undef
            filterStringAlgolia += ' AND categories.id_category:' + this.categoryId
          } else {
            // eslint-disable-next-line no-undef
            filterStringAlgolia += 'categories.id_category:' + this.categoryId
          }
        }
        if (this.brandName) {
          if (filterStringAlgolia.length > 0) {
            // eslint-disable-next-line no-undef
            filterStringAlgolia += ' AND brand:' + this.brandName
          } else {
            // eslint-disable-next-line no-undef
            filterStringAlgolia += 'brand:' + this.brandName
          }
        }
        if (this.labels) {
          if (filterStringAlgolia.length > 0) {
            // eslint-disable-next-line no-undef
            filterStringAlgolia += ' AND labels:' + this.labels
          } else {
            // eslint-disable-next-line no-undef
            filterStringAlgolia += 'labels:' + this.labels
          }
        }

        // eslint-disable-next-line no-undef
        if (this.categoryId) {
          if (selectedStringURL.length > 0) {
            if (this.querySearch) {
              window.history.replaceState(
                null,
                '',
                '?search_query=' + this.querySearch + '&filters=' + selectedStringURL + '&category=' + this.categoryId + '&' + sortUrl
              )
            } else {
              window.history.replaceState(
                null,
                '',
                '?filters=' + selectedStringURL + '&category=' + this.categoryId + '&' + sortUrl
              )
            }
          } else {
            if (this.querySearch) {
              window.history.replaceState(
                null,
                '',
                '?search_query=' + this.querySearch + '&category=' + this.categoryId + '&' + sortUrl
              )
            } else {
              window.history.replaceState(
                null,
                '',
                '?category=' + this.categoryId + '&' + sortUrl
              )
            }
          }
        } else if (this.brandName || this.labels) {
          if (selectedStringURL.length > 0) {
            window.history.replaceState(
              null,
              '',
              '?filters=' + selectedStringURL + '&' + sortUrl
            )
          } else {
            removeUrlParametr(['filters'])
          }
        } else {
          if (selectedStringURL.length > 0) {
            window.history.replaceState(
              null,
              '',
              '?controller=search' + '&' + sortUrl + '&search_query=' + this.querySearch + '&filters=' + selectedStringURL
            )
          } else {
            window.history.replaceState(
              null,
              '',
              '?controller=search' + '&' + sortUrl + '&search_query=' + this.querySearch
            )
          }
        }

        let algoliaQuery = [
          {
            // eslint-disable-next-line camelcase
            indexName: product_name + sortType,
            query: this.querySearch,
            params: {
              hitsPerPage: this.productperpage,
              filters: filterStringAlgolia,
              facetFilters: filterArray,
              page: 0,
              facets: ['*']
            }
          }
        ]

        selectedParent = selectedParent.filter(function (item, pos) {
          return selectedParent.indexOf(item) === pos
        })

        selectedParent.forEach(item => {
          let filterArraySlice = filterArray.map(item2 => {
            if (!item2.toString().includes(item)) {
              return item2
            } else {
              return ''
            }
          })
          let query = {
            // eslint-disable-next-line camelcase
            indexName: product_name + sortType,
            query: this.querySearch,
            filters: filterStringAlgolia,
            params: {
              facets: item,
              facetFilters: filterArraySlice
            }
          }
          algoliaQuery.push(query)
        })
        index
          .search(algoliaQuery)
          .then(response => {
            this.queryResultsProducts = []
            this.searchProductKey++
            this.productCount = response.results[0].nbHits
            this.queryResultsProducts = response.results[0]
            this.multipleList = response
            this.algoliaFinish = true
            if (this.postCount === 0 && this.productCount === 0) {
              this.notFound = true
            }
            setTimeout(() => {
              renderProductsListRatings()
            }, 1)
            this.notPagePresta = true
            this.searchProductKey += 1
            pagePresta.forEach(function (item) {
              item.style.display = 'none'
            })
            pagePrestaCategory.forEach(function (item) {
              item.style.display = 'block'
            })
            this.filterCategory(response.results[0])
          })
      }
    },
    changeSort (name) {
      let pagePresta = document.querySelectorAll('.hide_if_vue')
      let pagePrestaCategory = document.querySelectorAll('.show_if_vue')
      let url = window.location.search
      let sortType = ''
      let filterStringAlgolia = ''
      let filtersArray = []
      let selectedParent = []
      let filterArray = []
      let filtersString = getUrlParameter('filters')
      let filtersStringItem = filtersString.split('|')
      if (name === 'Cena: od najwyższej') {
        sortType = '_price_desc'
        window.history.replaceState(
          null,
          '',
          updateUrlParametr(url, 'orderway', 'desc'),
          updateUrlParametr(url, 'orderby', 'price')
        )
        let url2 = window.location.search
        window.history.replaceState(
          null,
          '',
          updateUrlParametr(url2, 'orderby', 'price')
        )
        removeUrlParametr(['p'])
      } else if (name === 'Cena: od najniższej') {
        sortType = '_price_asc'
        window.history.replaceState(
          null,
          '',
          updateUrlParametr(url, 'orderway', 'asc')
        )
        let url2 = window.location.search
        window.history.replaceState(
          null,
          '',
          updateUrlParametr(url2, 'orderby', 'price')
        )
        removeUrlParametr(['p'])
      } else if (name === 'Promocje') {
        window.history.replaceState(
          null,
          '',
          updateUrlParametr(url, 'orderby', 'promo')
        )
        sortType = '_promo'
        removeUrlParametr(['p', 'orderway'])
      } else if (name === 'Nowości') {
        sortType = '_new'
        window.history.replaceState(
          null,
          '',
          updateUrlParametr(url, 'orderby', 'new')
        )
        removeUrlParametr(['p', 'orderway'])
      } else if (name === 'Najlepiej ocenione') {
        sortType = '_rate'
        window.history.replaceState(
          null,
          '',
          updateUrlParametr(url, 'orderby', 'rate')
        )
        removeUrlParametr(['p', 'orderway'])
      } else if (name === 'Popularne') {
        removeUrlParametr(['p', 'orderway', 'orderby'])
      }

      filtersStringItem.forEach(item => {
        let itemsplit = item.split(':')
        let itemArray = []
        for (let i = 0; i < itemsplit.length; i++) {
          if (i === 0) {
            itemArray['name'] = itemsplit[i]
          } else {
            itemArray['value'] = []
            itemsplit[i].split(',').forEach(value => {
              itemArray['value'].push(value)
            })
          }
        }
        filtersArray.push(itemArray)
      })
      this.filtersArrayFromURL = filtersArray
      if (this.filtersArrayFromURL) {
        this.filtersArrayFromURL.forEach(item => {
          let filterGroup = []
          if (item.value !== undefined) {
            item.value.forEach(item2 => {
              if (filterStringAlgolia.length === 0) {
                if (item.name === 'brand') {
                  selectedParent.push(item.name)
                  filterGroup.push(item.name + ':' + item2)
                } else if (item.name === 'labels') {
                  selectedParent.push(item.name)
                  filterGroup.push(item.name + ':' + item2)
                } else {
                  selectedParent.push('features.' + item.name)
                  filterGroup.push('features.' + item.name + ':' + item2)
                }
              }
            })
          }
          if (filterGroup.length > 0) {
            filterArray.push(filterGroup)
          }
        })
      }
      // eslint-disable-next-line no-undef
      if (this.categoryId) {
        if (filterStringAlgolia.length > 0) {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += ' AND categories.id_category:' + this.categoryId
        } else {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += 'categories.id_category:' + this.categoryId
        }
      }
      if (this.brandName) {
        if (filterStringAlgolia.length > 0) {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += ' AND brand:' + this.brandName
        } else {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += 'brand:' + this.brandName
        }
      }
      if (this.labels) {
        if (filterStringAlgolia.length > 0) {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += ' AND labels:' + this.labels
        } else {
          // eslint-disable-next-line no-undef
          filterStringAlgolia += 'labels:' + this.labels
        }
      }

      let algoliaQuery = [{
        // eslint-disable-next-line camelcase
        indexName: product_name + sortType,
        query: this.querySearch,
        params: {
          hitsPerPage: this.productperpage,
          filters: filterStringAlgolia,
          facetFilters: filterArray,
          page: 0,
          facets: ['*']
        }
      }]

      selectedParent = selectedParent.filter(function (item, pos) {
        return selectedParent.indexOf(item) === pos
      })

      selectedParent.forEach(item => {
        let filterArraySlice = filterArray.map(item2 => {
          if (!item2.toString().includes(item)) {
            return item2
          } else {
            return ''
          }
        })
        let query = {
          // eslint-disable-next-line camelcase
          indexName: product_name + sortType,
          query: this.querySearch,
          filters: filterStringAlgolia,
          params: {
            facets: item,
            facetFilters: filterArraySlice
          }
        }
        algoliaQuery.push(query)
      })

      index.search(algoliaQuery)
        .then(response => {
          this.algoliaFinish = true
          this.queryResultsProducts = []
          this.searchProductKey++
          this.queryResultsProducts = response.results[0]
          this.productCount = response.results[0].nbHits
          this.searchFinish = true
          if (
            this.productCount === 0 ||
            this.queryResultsProducts.hits.length === 0
          ) {
            this.notFound = true
          }
          setTimeout(() => {
            renderProductsListRatings()
          }, 1)
          this.filterCategory(response.results[0])
          this.notPagePresta = true
          this.searchProductKey += 1
          pagePresta.forEach(function (item) {
            item.style.display = 'none'
          })
          pagePrestaCategory.forEach(function (item) {
            item.style.display = 'block'
          })
        })
    },
    filterCategory (filter) {
      var showCategory = filter.facets
      var categoryList = []
      Object.keys(showCategory).map(function (key) {
        let name = key
        name = name.substring(name.indexOf('.') + 1)
        let feature = []
        feature['name'] = name
        feature['value'] = []
        if (name === 'id_category') {
          Object.keys(showCategory[key]).map(function (key2) {
            let featureValue = []
            featureValue['name'] = key2
            featureValue['value'] = showCategory[key][key2]
            feature['value'].push(featureValue)
          })
          categoryList = feature
        }
      })
      var categoryDom = document.querySelectorAll('body:not(.category) .category-item-vue')
      categoryDom.forEach(item => {
        item.classList.remove('show-menu')
        item.parentElement.classList.remove('li-has-id')
        categoryList.value.forEach(item2 => {
          if (item.getAttribute('data-id') === item2.name) {
            item.parentElement.classList.add('li-has-id')
            item.classList.add('show-menu')
          }
        })
      })
      // eslint-disable-next-line no-undef
      jQuery('.li-has-id').each(function (item) {
        // eslint-disable-next-line no-undef
        if (jQuery(this).find('.li-has-id').length > 0) {
          // eslint-disable-next-line no-undef
          jQuery(this).children('.grower').show()
        } else {
          // eslint-disable-next-line no-undef
          jQuery(this).children('.grower').hide()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.searchPage {
  opacity: 0;
  min-height: 55px;
  &.searchPage-loaded {
    opacity: 1;
  }
  @media all and (max-width: 767px) {
    min-height: 41px;
  }
}
.loader,
.loader:before,
.loader:after {
  border-radius: 50%;
  width: 2.5em;
  height: 2.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
}
.loader {
  color: #88b330;
  font-size: 10px;
  margin: 80px auto;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loader:before,
.loader:after {
  content: "";
  position: absolute;
  top: 0;
}
.loader:before {
  left: -3.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loader:after {
  left: 3.5em;
}
@-webkit-keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
.fade-enter-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

</style>
<style lang="scss">
  .ps__thumb-y {
    background: #8AB82D !important;
    border-radius: 0;
    width: 3px !important;
  }
  .ps__rail-y{
    opacity: 1 !important;
    background: none !important;
    width: 3px !important;
  }
  .categories_tree_block > ul {
    // display: block !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Algolia/App.vue